// removed by extract-text-webpack-plugin
module.exports = {"imagenOriginal":"ZoomImagen__imagenOriginal___2Ixk2","tooltip":"ZoomImagen__tooltip___E0-Hn","tooltiptext":"ZoomImagen__tooltiptext___2rERd","imagenZoom":"ZoomImagen__imagenZoom___38dUk","imagenZoom1":"ZoomImagen__imagenZoom1___3fhhm","imagenZoom2":"ZoomImagen__imagenZoom2___VOxz3","imagenZoom3":"ZoomImagen__imagenZoom3___2E7y9","imagenZoom4":"ZoomImagen__imagenZoom4___3EvCe"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/components/ZoomImagen/ZoomImagen.css
// module id = 1079
// module chunks = 0